export const eventType = {
    ACCOUNT_ACTIVATION: "AccountActivation",
    LOGIN: "Login",
    SIKKA_SCORES_AUTHORIZATION: "SikkaScoresAuthorization",
    SIKKA_SCORES_ENABLED: "SikkaScoresEnabled",
    SIKKA_SCORES_DISABLED: "SikkaScoresDisabled",
    PAGE_LOAD: "PageLoaded",
    DATE_SELECTION: "DateSelection",
    EXPORT_DATA: "ExportData",
    PATIENT_PROFILE: "PatientProfile",
    INSURANCE_ELIGIBILITY: "InsuranceEligibility",
    MEDICAL_CONDITION: "MedicalCondition",
    PAYMENT: "Payment",
    SETTINGS: "Settings",
    GROUPING: "Grouping",
    MESSAGING: "Messaging",
    VIDEO: "Video",
    LOGOUT: "Logout",
    EXTERNAL_LINK: "ExternalLink",
    RECORDS: "Records",
    PRACTICE_SELECTION: "PracticeSelection",
    HOVER_TOOLTIP: "HoverTooltip",
    CAMPAIGN: "Campaign",
    DESCRIPTION: "Description",
    SAIGE: "SAIGE",
    COMPLIANCE: "Compliance",
    MESSAGES: "Messages Page",
    USER_MANAGEMENT: "User Management",
    NAVIGATION: "Navigation",
    TEXT: "Text",
    ACCOUNT_RECEIVABLES: "Account Receivables",
    MMR: "Morning Meeting Lite",
    ELIGIBILITY_REQUESTS: "Eligibility Requests",
};

export const eventName = {
    TRIAL_ACCOUNT_ACTIVATE: "Trial Account Activated",
    TRIAL_LOGIN_SPU: "Login as Trial User from SPU",
    SUBSCRIBER_LOGIN_SPU: "Login as Subscriber from SPU",
    TRIAL_LOGIN: "Login as Trial User from Login Page",
    SUBSCRIBER_LOGIN: "Login as Subscriber from Login Page",
    READ_INSTRUCTION: "Read Instruction",
    AUTHORIZE_SIKKA_SCORES: "Authorize Sikka Scores",
    SIKKA_SCORES_ENABLED_FOR_PATIENT: "Sikka Scores Enabled for Patient",
    SIKKA_SCORES_ENABLED_FOR_PRACTICE: "Sikka Scores Enabled for Practice/s",
    SIKKA_SCORES_DISABLED_FOR_PATIENT: "Sikka Scores Disabled for Patient",
    SIKKA_SCORES_DISABLED_FOR_PRACTICE: "Sikka Scores Disabled for Practice/s",
    SIKKA_SCORES_ENABLED_FOR_PATIENTS: "Sikka Scores Enabled for Patients",
    HOME_PAGE_LOADED: "Home Page Loaded Successfully",
    CONSTRUCT_TABLE_DATE_SELECT: "Construct Table Date Selection",
    EXPORT_EXCEL: "Export Excel",
    EXPORT_PDF: "Export PDF",
    OPEN_PATIENT_PROFILE: "Open Patient Profile",
    DOWNLOAD_INSURANCE_ELIGIBILITY: "Download Insurance Eligibility",
    INPUT_INSURANCE_CREDENTIALS: "Input Insurance Credentials",
    ADD_MEDICAL_NOTE: "Add/Edit patient's medical note",
    OPEN_PAYMENT_MODAL: "Open Payment modal",
    SIKKA_SCORES_ENABLED_IN_PATIENT_PROFILE:
        "Sikka Scores Enabled in Patient Profile",
    SIKKA_SCORES_DISABLED_IN_PATIENT_PROFILE:
        "Sikka Scores Disabled in Patient Profile",
    OPEN_GROUPING_MODAL: "Open Grouping modal",
    SELECT_PRACTICE_OR_GROUP: "Select Practice/Group",
    EDIT_GROUP: "Edit Group",
    CREATE_GROUP: "Create Group",
    DELETE_GROUP: "Delete Group",
    OPEN_PROFILE_MENU: "Open Profile Menu",
    MESSAGING: "Messaging",
    VIEW_INTRODUCTION_VIDEO: "View Introduction Video",
    LOGOUT: "Logout",
    OPTIMIZER: "Optimizer",
    REVIEW_TOS: "Review Term of Service",
    CREDIT_CARD_PAYMENT: "Credit Card Payment",
    STORED_CARD_PAYMENT: "Stored Card Payment",
    CASH_PAYMENT: "Cash Payment",
    TEXT2PAY: "Text2Pay",
    OPEN_PREFERENCES_NODAL: "Open Preferences modal",
    ADD_PAYMENT_CONFIG: "Add New Payment Configuration",
    EDIT_PAYMENT_CONFIG: "Update Existing Payment Configuration",
    SETTINGS_PAGE_LOAD: "Settings Page loaded",
    UPLOAD_LOGO: "Upload Logo",
    DELETE_LOGO: "Delete Logo",
    RECORDS_PAGE_LOAD: "Records Page loaded",
    REFRESH_RECORDS: "Refresh Payment Request data",
    PRINT: "Print document",
    SELECT_PRACTICE_FROM_DROPDOWN: "Practice Selection from dropdown",
    HOVER_TOOLTIP_INSURANCE_ELIGIBILITY: "Hover tooltip Insurance Eligibility",
    HOVER_TOOLTIP_HEALTH_RISK: "Hover tooltip Health Risk",
    HOVER_TOOLTIP_ECONOMIC_WELL_BEING: "Hover tooltip Economic Well Being",
    HOVER_TOOLTIP_TREATMENT_PLAN: "Hover tooltip Treatment Plan",
    OPEN_EXPERIENCE_SDP_MODAL: "Open 'Experience Self-Driving Practice' modal",
    ACTIVATE_CAMPAIGN: "Activate Campaign",
    CHANGE_TABLE_SETTINGS: "Change Contruct Table Settings",
    LOAD_RECORDS_PAGE: "Loaded Records page",
    OPEN_TREATMENT_PLAN_MODAL: "Open Treatment Plan Modal",
    CLICK_FAMILY_MEMBER_OR_GUARANTOR:
        "Click to view Family Member/Guarator Profile",
    CLICK_NAVIGATE_TO_OPTIMIZER:
        "Click 'Navigate to Optimizer' button in Nav Bar",
    OPEN_VIDEO_MODAL: "Open Video Modal",
    SELECT_INSURANCE_COMPANY: "Select Insurance Company from dropdown",
    UPDATE_INSURANCE_CREDENTIALS: "Update Insurance Company Credentials Info",
    CLICK_EDIT_ICON_INSURANCE_CREDENTIALS:
        "Click edit icon to start edit Insurance Credentials",
    OPEN_INSURANCE_ELIGIBILITY_MODAL: "Open Insurance Eligibility Modal",
    SWITCH_NETWORK_TAB: "Switch Network tab",
    SEARCH_PROC_CODE: "Search for specific procedure code",
    FETCH_INSURANCE_ELIGIBILITY_DATA: "Fetched Insurance Eligibility Data",
    HOVER_TOOLTIP: "Hover Tooltip",
    SEARCH_SAIGE: "Search by using SAIGE",
    OPEN_COMPLIANCE_MODAL: "Open Compliance Modal",
    SEND_MAIL: "Compose a mail and click 'Send Message' button",
    CONFIRM_APPOINTMENT: "Confirm an appointment request",
    DELETE_MESSAGES: "Delete Messages",
    OPEN_COMPOSE_MAIL_MODAL: "Open 'Compose Mail' modal",
    INBOX_TAB: "Inbox tab on Messages page",
    SENT_TAB: "Sent tab on Messages page",
    APPOINTMENT_TAB: "Appointment tab on Messages page",
    FEEDBACK_TAB: "Feedback tab on Messages page",
    ADD_NEW_USER: "Add new user",
    EDIT_USER: "Edit User Information",
    VIEW_USER: "View User Information",
    DELETE_USER: "Delete User",
    EDIT_PRACTICE_OR_GROUP:
        "Save updated Practices Or Groups assigned For user",
    UPDATE_USER: "Save Updated user information",
    DELETE_ASSIGNED_PRACTICE: "Delete assigned Practice",
    DELETE_ASSIGNED_GROUP: "Delete assigned Group",
    SAVE_NEW_USER: "Save new user info",
    SAVE_PRACTICES_GROUPS: "Save practices or groups for new user",
    SAVE_FEATURES: "Save Features for new user",
    LOGIN_AS_SIKKA_ADMIN: "Login as Sikka Admin",
    CLICK_ON_SETTINGS_MENU: "Click on Menu sidebar item in Settings page",
    SAVE_EDIT_PRACTICE_DETAILS: "Save Changes in Practice Details",
    EDIT_PRACTICE_DETAILS: "Click Edit button in Practice Details",
    SAVE_PAYMENT_API_CONFIG: "Save changes after editing Payment API Config",
    SAVE_SCHEDULER_TIME: "Save changes after editing Scheduler Time",
    SAVE_PROCEDURE_DURATION: "Save changes after editing Procedure Duration",
    SAVE_REGIONAL_SETTINGS: "Save changes of Regional Settings",
    SAVE_WRITEBACK_SETTINGS: "Save changes after editing Write Back Settings",
    SAVE_APPOINTMENT_CONFIRMATION:
        "Save changes after editing Appointment Confirmation settings",
    SAVE_APPOINTMENT_NOTIFICATIONS:
        "Save changes after editing Appointment Notifications settings",
    OPEN_COMPOSE_TEXT: "Open Compose text modal",
    SEND_TEXT: "Send a composed text to patient/s",
    REPLY_TEXT: "Reply to a text from a patient",
    NAVIGATE_CAMPAIGN_STEP: "Navigate between Create Campaign steps",
    DISCARD_CREATE_CAMPAIGN: "Discard a new campaign",
    DISCARD_EDIT_CAMPAIGN: "Discard a campaign while editing",
    CHOOSE_CAMPAIGN: "Choose one of the campaigns to create",
    SAVE_FREQUENCY: "Input frequency settings and click Next",
    DELETE_TEMPLATE: "Delete template",
    SAVE_NEW_TEMPLATE: "Create new template",
    SAVE_AND_CONTINUE:
        "Save the selected template for campaign and Continue to next step",
    SAVE_EDITING: "Edit any template and save",
    UPLOAD_IMAGE: "Upload images for email template",
    DELETE_IMAGE: "Delete images for email template",
    RESET_PATIENT_LIST: "Reset patient list with default filters",
    APPLY_FILTER: "Apply filter to fetch patient list",
    SELECT_LIST: "Select audience list for campaign",
    SET_SCHEDULE: "Save Schedule settings for campaign",
    SET_PROGRAM_NAME: "Save campaign name",
    VIEW_CAMPAIGN: "View perticular Campaign details",
    DEACTIVATE_CAMPAIGN: "Deactivate campaign",
    DELETE_CAMPAIGN: "Delete Campaign",
    RECEIVABLES_TAB: "Receivables",
    RECORDS_TAB: "Records",
    MONTH_TO_DATE: "Month To Date",
    WEEK_TO_DATE: "Week To Date",
    LAST_WORKING_DAY: "Last Working Day",
    TO_DATE: "To Date to show data for selected Date",
    VS_LAST: "Vs Last to compare data from previous year for selected date",
    MMR_DATE_SELECT: "MMR Date Selection",
    SELECT_PRACTICE_IN_GROUPING_MODAL: "Select Practice in Grouping modal",
    SELECT_GROUP_IN_GROUPING_MODAL: "Select Group in Grouping modal",
    SELECT_DATEPICKER_IN_COMMON_HEADER: "Select a date in Common Header",
    SWITCH_SETTINGS_TAB: "Click on Settings tab",
    SIKKA_SCORES_DISABLED_FOR_PATIENTS: "Disabled Sikka Score for a Patient",
    INSURANCE_ELIGIBILITY_AGREE: "Agree with Insurance Eligibility Fee TOS",
    VIEW_ELIGIBILITY_REPORT: "View Eligibility Report",
    UPDATE_ADDED_TO_LEDGER_STATUS: "Check/Uncheck Added to Ledger checkbox",
};
